"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = require("prop-types");

var _Visibility = _interopRequireDefault(require("@material-ui/icons/Visibility"));

var _VisibilityOff = _interopRequireDefault(require("@material-ui/icons/VisibilityOff"));

var _HelpOutline = _interopRequireDefault(require("@material-ui/icons/HelpOutline"));

var _TextField = _interopRequireDefault(require("@material-ui/core/TextField"));

var _IconButton = _interopRequireDefault(require("@material-ui/core/IconButton"));

var _InputAdornment = _interopRequireDefault(require("@material-ui/core/InputAdornment"));

var _Grid = _interopRequireDefault(require("@material-ui/core/Grid"));

var _form = require("@widergy/web-utils/lib/form");

var _seamlessImmutable = require("seamless-immutable");

var _WithTheme = _interopRequireDefault(require("../WithTheme"));

var _UTTooltip = _interopRequireDefault(require("../UTTooltip"));

var _formTypes = require("../../types/formTypes");

var _stylesJS = _interopRequireDefault(require("./stylesJS"));

var _stylesModule = _interopRequireDefault(require("./styles.module.scss"));

var _theme = require("./theme");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      "default": obj
    };
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj["default"] = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var preventDefault = function preventDefault(event) {
  if (event.key === 'Enter') {
    event.preventDefault();
  }
};

var UTTextInput = /*#__PURE__*/function (_PureComponent) {
  _inherits(UTTextInput, _PureComponent);

  function UTTextInput() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, UTTextInput);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(UTTextInput)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _defineProperty(_assertThisInitialized(_this), "state", {
      visible: false
    });

    _defineProperty(_assertThisInitialized(_this), "handleClickShowPassword", function () {
      _this.setState(function (prevState) {
        return {
          visible: !prevState.visible
        };
      });
    });

    return _this;
  }

  _createClass(UTTextInput, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          classes = _this$props.classes,
          input = _this$props.input,
          placeholder = _this$props.placeholder,
          label = _this$props.label,
          meta = _this$props.meta,
          disabled = _this$props.disabled,
          type = _this$props.type,
          bigInput = _this$props.bigInput,
          inputClassName = _this$props.inputClassName,
          labelRootClassName = _this$props.labelRootClassName,
          containerClassName = _this$props.containerClassName,
          tooltip = _this$props.tooltip,
          preventEnterSubmit = _this$props.preventEnterSubmit,
          id = _this$props.id,
          autofocus = _this$props.autofocus,
          onChangeText = _this$props.onChangeText,
          field = _this$props.field,
          tippyProps = _this$props.tippyProps;

      var handleChange = function handleChange(event) {
        return input.onChange(onChangeText(event.target.value));
      };

      var Icon = (0, _seamlessImmutable.getIn)(field, ['configuration', 'icon']);
      var outsideIcon = (0, _seamlessImmutable.getIn)(field, ['configuration', 'outsideIcon']);
      outsideIcon = (0, _react.isValidElement)(outsideIcon) && outsideIcon;
      var adornment = (0, _seamlessImmutable.getIn)(field, ['configuration', 'adornment']);
      var endAction = type === 'password' ? _react["default"].createElement(_IconButton["default"], {
        onClick: this.handleClickShowPassword
      }, !this.state.visible ? _react["default"].createElement(_VisibilityOff["default"], null) : _react["default"].createElement(_Visibility["default"], null)) : adornment;

      var TextInput = _react["default"].createElement(_TextField["default"], {
        id: id || '',
        placeholder: placeholder,
        label: Icon ? _react["default"].createElement("div", {
          className: classes.labelContainer
        }, _react["default"].createElement(Icon, {
          className: classes.labelIcon
        }), _react["default"].createElement("div", null, label)) : label,
        onKeyPress: preventEnterSubmit ? preventDefault : undefined,
        error: (0, _form.shouldShowErrors)(meta),
        helperText: (0, _form.shouldShowErrors)(meta) && meta.error || '',
        disabled: disabled,
        onChange: handleChange,
        value: input.value,
        fullWidth: true,
        autoFocus: autofocus,
        margin: "none",
        autoComplete: "off",
        InputProps: {
          endAdornment: endAction && _react["default"].createElement(_InputAdornment["default"], {
            position: "end"
          }, " ", endAction, " "),
          type: type === 'password' && !this.state.visible ? 'password' : 'text',
          classes: {
            input: "".concat(bigInput && classes.bigInput, " ").concat(inputClassName)
          }
        },
        InputLabelProps: {
          classes: {
            root: labelRootClassName
          }
        }
      });

      return _react["default"].createElement("div", {
        className: "".concat(classes.container, " ").concat(containerClassName)
      }, tooltip ? _react["default"].createElement(_react.Fragment, null, _react["default"].createElement(_Grid["default"], {
        style: _stylesJS["default"].gridContainer,
        container: true,
        spacing: 1,
        alignItems: "flex-end"
      }, _react["default"].createElement(_Grid["default"], {
        item: true,
        xs: true
      }, TextInput), _react["default"].createElement(_Grid["default"], {
        item: true,
        style: _stylesJS["default"].icon
      }, _react["default"].createElement(_UTTooltip["default"], {
        tippyProps: tippyProps,
        content: tooltip
      }, _react["default"].createElement("span", null, _react["default"].createElement(_HelpOutline["default"], {
        className: classes.tooltipIcon
      })))))) : _react["default"].createElement(_react.Fragment, null, outsideIcon && _react["default"].createElement("div", {
        className: _stylesModule["default"].iconContainer
      }, outsideIcon), TextInput));
    }
  }]);

  return UTTextInput;
}(_react.PureComponent);

UTTextInput.propTypes = {
  type: _propTypes.string,
  placeholder: _propTypes.string,
  containerClassName: _propTypes.string,
  input: _formTypes.inputPropTypes.isRequired,
  meta: _formTypes.metaPropTypes.isRequired,
  disabled: _propTypes.bool,
  tooltip: _propTypes.string,
  bigInput: _propTypes.bool,
  labelRootClassName: _propTypes.string,
  inputClassName: _propTypes.string,
  label: _propTypes.string,
  classes: _propTypes.any,
  field: _propTypes.any,
  preventEnterSubmit: _propTypes.bool,
  id: _propTypes.string,
  autofocus: _propTypes.bool,
  onChangeText: _propTypes.func,
  tippyProps: _propTypes.any
};
UTTextInput.defaultProps = {
  classes: {},
  preventEnterSubmit: false,
  autofocus: false,
  onChangeText: function onChangeText(val) {
    return val;
  }
};

var _default = (0, _WithTheme["default"])(_theme.retrieveStyle, _theme.retrieveMuiTheme)(UTTextInput);

exports["default"] = _default;